import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Card } from "react-bootstrap";
import Layout from "../Components/Layout/Layout";
import {
  collectiondetailsAction,
  saveCollectionToSelf,
} from "../Redux/Action/CollectionAction";
import { useDispatch, useSelector } from "react-redux";
import LoaderComponent from "../Components/common/LoaderComponent";
import { Decryptedid, Encryptedid } from "../Util/BcruptEncyptid";
import { truncateTextbrowse } from "../Util/HelperFunction";
import { activityListAction } from "../Redux/Action/AuthAction";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TfiAlert } from "react-icons/tfi";
import { groupData } from "../Constant/ConstantData";

export default function SharedCollection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, type } = useParams();
  const [idval, setIdval] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const safeDecrypt = () => {
      try {
        const decoded = atob(id);
        const decrypted = Decryptedid(decoded);
        return decrypted && decrypted.trim() ? decrypted.trim() : id;
      } catch (error) {
        console.error("Decryption failed:", error);
        return id;
      }
    };

    setIdval(safeDecrypt());
  }, [id]);
  const collectiondetails = useSelector(
    (state) => state?.collectionSlice?.collectionDetails
  );

  useEffect(() => {
    if (!idval) return;
    setIsLoading(true);
    const fetchCollectionDetails = () =>
      dispatch(collectiondetailsAction(idval));
    const fetchActivityData = () =>
      dispatch(activityListAction({ id: collectiondetails?._id }));
    Promise.all([fetchActivityData(), fetchCollectionDetails()]).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch, idval, collectiondetails?._id]);

  useEffect(() => {
    if (type === "student") {
      window.location.href = `https://apps.apple.com/in/app/peerscroller/${idval}`;
    }
  }, [type, idval]);

  const gotoPlayback = (collectionId, videoId) => {
    navigate(`/collection-shorts/${Encryptedid(collectionId)}/${videoId}`);
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSaveCollection = () => {
    setIsSaving(true);
    dispatch(saveCollectionToSelf({ collectionId: idval }))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          navigate(`/collection-detail/${Encryptedid(idval)}`);
        }
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const renderTooltip = (res) => (props) =>
    (
      <Tooltip id="custom-tooltip" {...props} className="custom-tooltip">
        <h4 className="contains-head">Contains sensitive content:</h4>
        <p className="conatin-desc m-0 ">{res?.sensitiveType}</p>
        <div className="tooltip-arrow-custom" />
      </Tooltip>
    );

  return (
    <Layout>
      <>
        <Container fluid className="px-4">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center py-4 border-bottom">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className="p-0 me-3 text-decoration-none"
                onClick={() => navigate(-1)}
                style={{ color: "#6c757d" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
              </Button>
              <div>
                <p className="text-muted mb-1 small">
                  Collections / {collectiondetails?.name}
                </p>
                <h2 className="mb-0 fw-bold" style={{ color: "#2c3e50" }}>
                  {collectiondetails?.name}
                </h2>
              </div>
            </div>
            <Button
              variant="primary"
              onClick={handleSaveCollection}
              className="d-flex align-items-center gap-2 px-4 py-2"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                border: "none",
                borderRadius: "12px",
                fontWeight: "500",
              }}
              disabled={isSaving}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17,21 17,13 7,13 7,21" />
                <polyline points="7,3 7,8 15,8" />
              </svg>
              {isSaving ? "Saving...." : "Save Collection"}
            </Button>
          </div>

          {/* Content Section */}
          <div className="py-4">
            {isLoading ? (
              <LoaderComponent />
            ) : (
              <>
                {Array.isArray(collectiondetails?.video) &&
                collectiondetails?.video.length > 0 ? (
                  <>
                    <div className="mb-4">
                      <h5 className="text-muted mb-3">
                        {collectiondetails?.video.length} Videos in Collection
                      </h5>
                    </div>
                    <Row className="g-3">
                      {collectiondetails?.video.map((ele, index) => (
                        <Col xxl={3} xl={4} lg={4} md={6} sm={12} key={index}>
                          <Card
                            className="video-card border-0 h-100"
                            style={{
                              borderRadius: "12px",
                              overflow: "hidden",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            }}
                            onClick={() =>
                              gotoPlayback(collectiondetails?._id, ele?._id)
                            }
                          >
                            {/* Full Height Thumbnail */}
                            <div
                              className="position-relative"
                              style={{ height: "500px", overflow: "hidden" }}
                            >
                              {ele?.cover_url ? (
                                <Card.Img
                                  variant="top"
                                  src={ele.cover_url}
                                  alt={ele.title}
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.transform = "scale(1.05)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.transform = "scale(1)";
                                  }}
                                />
                              ) : (
                                <div
                                  className="d-flex align-items-center justify-content-center h-100"
                                  style={{
                                    background:
                                      "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
                                  }}
                                >
                                  <svg
                                    width="80"
                                    height="80"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#cbd5e1"
                                    strokeWidth="1"
                                  >
                                    <polygon points="5,3 19,12 5,21" />
                                  </svg>
                                </div>
                              )}

                              {/* Play Button Overlay */}
                              <div
                                className="position-absolute top-50 start-50 translate-middle play-overlay"
                                style={{
                                  opacity: 0,
                                  transition: "all 0.3s ease",
                                  transform: "translate(-50%, -50%) scale(0.8)",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    backgroundColor: "rgba(255,255,255,0.95)",
                                    borderRadius: "50%",
                                    boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                                  }}
                                >
                                  <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="#3b82f6"
                                    style={{ marginLeft: "3px" }}
                                  >
                                    <polygon points="5,3 19,12 5,21" />
                                  </svg>
                                </div>
                              </div>

                              {/* Duration Badge */}
                              {ele?.video_duration && (
                                <span
                                  className="position-absolute text-white px-2 py-1"
                                  style={{
                                    bottom: "12px",
                                    right: "12px",
                                    backgroundColor: "rgba(0,0,0,0.85)",
                                    borderRadius: "6px",
                                    fontSize: "0.8rem",
                                    fontWeight: "600",
                                    letterSpacing: "0.5px",
                                  }}
                                >
                                  {ele.video_duration}
                                </span>
                              )}

                              {/* Video Index */}
                              <span
                                className="position-absolute text-white"
                                style={{
                                  top: "12px",
                                  right: "12px",
                                  backgroundColor: "rgba(0,0,0,0.7)",
                                  borderRadius: "12px",
                                  padding: "4px 10px",
                                  fontSize: "0.75rem",
                                  fontWeight: "600",
                                }}
                              >
                                #{index + 1}
                              </span>

                              {/* Sensitive Content Warning */}
                              {ele?.isSensitive && (
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip(ele)}
                                >
                                  <span
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "12px",
                                      backgroundColor: "rgba(255,193,7,0.9)",
                                      borderRadius: "50%",
                                      width: "36px",
                                      height: "36px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#fff",
                                    }}
                                  >
                                    <TfiAlert size={18} />
                                  </span>
                                </OverlayTrigger>
                              )}
                            </div>

                            {/* Card Content */}
                            <Card.Body className="p-4">
                              <Card.Title
                                className="mb-2 fw-bold"
                                style={{
                                  fontSize: "1.1rem",
                                  color: "#1e293b",
                                  lineHeight: "1.4",
                                  minHeight: "2.8rem",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                }}
                              >
                                {ele?.title}
                              </Card.Title>

                              {ele?.description && (
                                <Card.Text
                                  className="text-muted mb-3"
                                  style={{
                                    fontSize: "0.9rem",
                                    lineHeight: "1.5",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                  }}
                                >
                                  {truncateTextbrowse(ele.description, 6)}
                                </Card.Text>
                              )}

                              {/* Tags */}
                              {ele?.group?.length > 0 && (
                                <div className="d-flex flex-wrap gap-2">
                                  {ele.group.slice(0, 3).map((id) => {
                                    const name = groupData.find(
                                      (g) => g.id === id
                                    )?.name;
                                    return (
                                      name && (
                                        <span
                                          key={id}
                                          className="badge"
                                          style={{
                                            backgroundColor: "#eff6ff",
                                            color: "#1d4ed8",
                                            fontSize: "0.75rem",
                                            fontWeight: "500",
                                            padding: "6px 12px",
                                            borderRadius: "20px",
                                            border: "1px solid #dbeafe",
                                          }}
                                        >
                                          {name}
                                        </span>
                                      )
                                    );
                                  })}
                                  {ele.group.length > 3 && (
                                    <span
                                      className="badge"
                                      style={{
                                        backgroundColor: "#f8fafc",
                                        color: "#64748b",
                                        fontSize: "0.75rem",
                                        fontWeight: "500",
                                        padding: "6px 12px",
                                        borderRadius: "20px",
                                        border: "1px solid #e2e8f0",
                                      }}
                                    >
                                      +{ele.group.length - 3} more
                                    </span>
                                  )}
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </>
                ) : (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center"
                    style={{ minHeight: "400px" }}
                  >
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ccc"
                      strokeWidth="1"
                      className="mb-3"
                    >
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                      <line x1="16" y1="2" x2="16" y2="6" />
                      <line x1="8" y1="2" x2="8" y2="6" />
                      <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    <h5 className="text-muted mb-2">No Videos Found</h5>
                    <p className="text-muted">
                      This collection doesn't contain any videos yet.
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </Container>
        <style jsx>{`
          .video-card:hover {
            transform: translateY(-6px);
            box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12) !important;
          }
          .video-card:hover .play-overlay {
            opacity: 1 !important;
            transform: translate(-50%, -50%) scale(1) !important;
          }
        `}</style>
      </>
    </Layout>
  );
}
